import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer
      className="relative text-white bg-cover bg-center"
      style={{
        backgroundImage: "url('/assets/images/about/bg.png')",
      }}
    >
      {/* Overlay with blur + dark tint */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 py-12">
        <div className="grid sm:grid-cols-5 gap-8">
          {/* Pune Address */}
          <div className="col-span-2">
            <h3 className="text-lg font-bold mb-4">Pune</h3>
            <div className="flex items-start">
              <FaMapMarkerAlt className="mt-1 mr-2 text-indigo-400" />
              <p className="text-gray-200 text-sm">
                Office no. 505, City Avenue, Oppo. Phoenix Mall of the Millennium, Mumbai-Bangalore Highway, Wakad, Pune 411057
                {/* <br /> Hinjawadi Phase II, Pune - 411057 */}
              </p>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div className="flex items-center mb-3">
              <FaEnvelope className="mr-2 text-gray-300" />
              <a
                href="mailto:connect@tissatech.com"
                className="text-gray-200 text-sm hover:text-white"
              >
                connect@tissatech.com
              </a>
            </div>
            <div className="flex items-center">
              <FaPhoneAlt className="mr-2 text-gray-300" />
              <p className="text-gray-200 text-sm">+91-9373772429</p>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:ms-6">
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              {["Home", "About Us", "Career"].map((link, i) => (
                <li key={i}>
                  <a
                    href={`/${link.toLowerCase().replace(/ /g, "-")}`}
                    className="text-gray-200 hover:text-white"
                  >
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-bold mb-4">Follow Us</h3>
            <div className="flex space-x-3">
              {[FaLinkedinIn,FaFacebookF, FaInstagram, FaYoutube].map(
                (Icon, i) => (
                  <a
                    key={i}
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-indigo-600 hover:bg-indigo-700 transition"
                  >
                    <Icon />
                  </a>
                )
              )}
            </div>
          </div>
        </div>

        {/* Divider & Bottom */}
        <div className="border-t border-gray-400 mt-10 pt-6 flex flex-col lg:flex-row justify-between items-center text-sm text-gray-300">
          <p className="">
            Copyright ©{" "}
            <span className="text-white font-semibold">
              STISSA Technology LLP (TISSA Technology)
            </span>
            . All Rights Reserved.
          </p>
          <div className="flex gap-4 mt-6 lg:mt-0">
            <a
              href="/privacy-policy"
              className="text-gray-200 hover:text-white"
            >
              Privacy Policy
            </a>
            |
            <a
              href="/terms-of-service"
              className="text-gray-200 hover:text-white"
            >
              Terms Of Service
            </a>
            
            <a
              href="#top"
              className="md:mt-0 bg-white px-3 py-1 rounded text-blue-700 text-xs hover:bg-gray-200 cursor-pointer transition"
            >
              ↑ Top
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
